export default __webpack_public_path__ + "static/header_image_one-c5e712d555ec485c7eebdc43fc21559c.jpg";